angular.module('impactx.condition').controller('ConditionDetailController', ConditionDetailController);
ConditionDetailController.$inject = [
    '$scope',
    'dataGen',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$routeParams',
    'ToolbarService'
];

function ConditionDetailController($scope, dataGen, BackService, $mdToast, ConfirmationService, $routeParams, ToolbarService) {
    var ctrl = this;
    dataGen.getData($scope, {id: $routeParams.id}, "/condition/view").then(function () {
        defineButtons();
    });

    ctrl.save = function () {
        var dataObj = {
            data: $scope.data
        };
        return dataGen.postAsForm($scope, dataObj, "/condition/save").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.getData($scope, dataObj, "/condition/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    $scope.filterPolicy = function (policy) {

        switch (policy.value) {
            case 0:
                //always, that's easy
                return true;
            case 1:
                //only for pos related conditions
                return $scope.data.posRelatedGroup.setId == 0;
            case 2:
            case 6:
                //filtered by backend
                return true;
            case 7:
            case 9:
            case 10:
                //only for not pos related conditions
                return $scope.data.posRelatedGroup.setId == 1;
            default:
                return false;
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return !$scope.data.readOnly && $scope.data.id > 0;
    }

    $scope.onChangeUseKeyCode = function () {
        if($scope.data.useUseKeyCode.value)
        {
            $scope.data.posRelatedGroup.setId = 0;
        }
    }
}